var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShape23 = function SvgShape23(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 94,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M147.421 123.134c0 2.952 0 4.428-.147 5.669a21.11 21.11 0 0 1-18.471 18.471c-1.241.147-2.717.147-5.669.147H24.866c-2.952 0-4.428 0-5.67-.147a21.11 21.11 0 0 1-18.47-18.471c-.147-1.241-.147-2.717-.147-5.669V74C.58 33.45 33.451.579 74 .579S147.421 33.45 147.421 74z",
    opacity: 0.1
  })));
};
export default SvgShape23;